import { diContainer, serviceNames } from './diContainer';
import { Service, ServiceInitializer } from 'elc-service';
import { VTO, VTO_SKIN_CARE } from 'elc-service-view-names';

const { name, version } = __serviceInfo__;

export class VtoService extends Service {
    constructor(serviceInitializer: ServiceInitializer) {
        super(name, version, serviceInitializer);

        this.registerView(
            VTO,
            () =>
                import(
                    /* webpackChunkName: 'Vto' */
                    '../exported/vto/Vto'
                ),
            // @ts-ignore
            () => diContainer.get(serviceNames.vtoViewController)
        );

        this.registerView(
            VTO_SKIN_CARE,
            () =>
                import(
                    /* webpackChunkName: 'VtoSkinCare' */
                    '../exported/vto-skin-care/VtoSkinCare'
                ),
            // @ts-ignore
            () => diContainer.get(serviceNames.vtoSkinCareViewController)
        );
    }
}
